import List from "./list/Statements";
import Individual from "./individual/Statement";

export default { List, Individual };
